import api from 'apis/config/files-api';
import { createAuthorizationHeader, getAccessToken } from 'apis/config/http-service';
import type { AxiosResponse } from 'axios';

/**
 * Uploads one image/PDF (form field `file`) to qsupply/backend and resolves with the legacy response shape:
 * callers read `response.data.url`, while the backend answers `{ data: { url } }`.
 * The extra parameters are kept for the legacy call sites; the upload endpoint no longer depends on them.
 */
export const uploadFileApi = (
  file: File | FormData,
  _url?: string,
  _token?: string,
  params?: Record<string, unknown>
): Promise<AxiosResponse<{ url: string }>> =>
  api
    .post('api/v1/cms/files/upload', file, {
      params,
      // Read the token per call: the files-api instance captures it at import time, possibly before login.
      headers: { 'Content-Type': 'multipart/form-data', Authorization: createAuthorizationHeader(getAccessToken()) },
    })
    .then((response: AxiosResponse<{ data: { url: string } }>) => ({ ...response, data: response.data.data }));
